// @ts-nocheck
import { Plugin } from '/home/jenkins/workspace/single-pos-ui/node_modules/@umijs/runtime';

const plugin = new Plugin({
  validKeys: ['modifyClientRenderOpts','patchRoutes','rootContainer','render','onRouteChange','__mfsu','dva','getInitialState','initialStateConfig','locale','layout','layoutActionRef','request','qiankun',],
});

export { plugin };
